import { CASAMAPA_ADMIN_PORTAL_BASE } from "./clientAdminPortalRoutes.js";
import { CASAMAPA_CLIENT_VIEW_SLUG } from "./casamapaPartnerPortalConfig.js";

export function casamapaVendorWorkspaceBase(clientViewId) {
  if (!clientViewId) return null;
  return `${CASAMAPA_ADMIN_PORTAL_BASE}/views/${clientViewId}/servicios`;
}

export function casamapaVendorWorkspacePath(clientViewId, ...segments) {
  const base = casamapaVendorWorkspaceBase(clientViewId);
  if (!base) return null;
  const tail = segments
    .filter((part) => part != null && String(part).length > 0)
    .map((part) => String(part).replace(/^\/+|\/+$/g, ""))
    .filter(Boolean)
    .join("/");
  return tail ? `${base}/${tail}` : base;
}

export function casamapaVendorWorkspaceVendorPath(clientViewId, vendorId) {
  return casamapaVendorWorkspacePath(clientViewId, "proveedores", vendorId);
}

export function casamapaVendorPublicProfilePath(vendorSlug) {
  return `/v/${CASAMAPA_CLIENT_VIEW_SLUG}/servicios/proveedor/${encodeURIComponent(vendorSlug)}`;
}

export function casamapaPublicVendorDirectoryHref(locale) {
  const segment = String(locale || "es-CO").split("-")[0];
  return segment === "es" ? `/v/${CASAMAPA_CLIENT_VIEW_SLUG}/servicios` : `/v/${CASAMAPA_CLIENT_VIEW_SLUG}/${segment}/servicios`;
}

export function casamapaPublicVendorProfileHref(vendorSlug, locale) {
  return `${casamapaPublicVendorDirectoryHref(locale)}/proveedor/${encodeURIComponent(vendorSlug)}`;
}

export const CASAMAPA_VENDOR_WORKSPACE_SECTIONS = {
  vendors: "proveedores",
  vendorCreate: "proveedores/nuevo",
  candidates: "candidatos",
  imports: "importaciones",
  duplicates: "duplicados",
  resolution: "resolucion",
  sources: "fuentes",
  collectionPlans: "colecciones/planes",
  collectionRuns: "colecciones/ejecuciones",
  verification: "verificacion",
  credentials: "credenciales",
  claims: "reclamaciones",
  privacy: "privacidad",
  privacyRetention: "privacidad/retencion",
  ranking: "posicionamiento",
  analytics: "analytics",
  maintenance: "mantenimiento",
  pilot: "piloto",
  expansion: "expansion",
  marketplace: "marketplace",
  settings: "configuracion",
};
